import { render, staticRenderFns } from "./CurrentVisits.vue?vue&type=template&id=0aef985b&scoped=true"
import script from "./CurrentVisits.vue?vue&type=script&lang=ts"
export * from "./CurrentVisits.vue?vue&type=script&lang=ts"
import style0 from "./CurrentVisits.vue?vue&type=style&index=0&id=0aef985b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef985b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aef985b')) {
      api.createRecord('0aef985b', component.options)
    } else {
      api.reload('0aef985b', component.options)
    }
    module.hot.accept("./CurrentVisits.vue?vue&type=template&id=0aef985b&scoped=true", function () {
      api.rerender('0aef985b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CurrentVisits.vue"
export default component.exports